export enum CallPriority {
  Fifo = 0,
}
